import React from 'react';
import SpendDashboardPage from '../../pages/spend-management/dashboard';
import ProtectedRoute from '../protected';

export const SpendDashboardRoutes = [
  <ProtectedRoute exact path='/dashboard' component={SpendDashboardPage} />,
];
